import AsyncCallHandler from '../common/AsyncCallHandler'
import ACTION_TYPES from './actionTypes'
import NEXUS_CONST from '../common/constants'
import { set, get } from '../common/utils'


export const fetchGallery = (dispatch, site) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_GALLERY, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: ACTION_TYPES.FETCH_GALLERY, payload: res.data });
        });
}

export const addGalleryFile = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.ADD_GALLERY_FILE, NEXUS_CONST.PUT, data)
        .then(res => {
            fetchGallery(dispatch, null)
        });
}

export const deleteGalleryFile = (dispatch, id) => {
    AsyncCallHandler(NEXUS_CONST.DELETE_GALLERY_FILE + id, NEXUS_CONST.POST)
        .then(res => {
            fetchGallery(dispatch, null)
        });
}